<template>
  <div class="custom-list-wrapper">
    <div v-if="isLoading" class="row">
      <div class="col text-center">
        <span>Loading...</span>
      </div>
    </div>
    <div v-else>
      <div class="row">
        <div class="col">
          <span class="custom-label">Invoice #</span>
        </div>
        <div class="col-3">
          <span class="custom-label ms-4">Date</span>
        </div>
        <div class="col-2 text-right">
          <span class="custom-label me-4">Amount</span>
        </div>
      </div>
      <ul class="custom-list">
        <li v-for="(item, idx) of invoices" :key="idx">
          <div class="row">
            <div class="col">
              {{ item.InvoiceNum }}
            </div>
            <div class="col-3">
              <span class="text-center me-2">{{ formatDate(item.CreateTime) }}</span>
            </div>
            <div class="col-2 text-right">
              <span class="text-right me-2">{{ item.Total.toFixed(2) }}</span>
            </div>
          </div>
        </li>
      </ul>
      <div class="row">
        <div class="col"></div>
        <div class="col-3 text-right">Total:</div>
        <div class="col-2 text-right">
          <span class="custom-label me-4">{{ total }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'pinia'
import { wasabiStore } from '@/stores/wasabi'
import globals from '@/plugins/globals'
export default {
  name: 'AccountInvoices',
  computed: {
    ...mapState(wasabiStore, ['loading', 'account', 'invoices']),
    isLoading() {
      let _is = false
      if (this.loading) {
        _is = this.loading.invoices
      }
      return _is
    },
    total() {
      let _total = 0
      if (this.invoices.length > 0) {
        _total = this.invoices.reduce((acc, item) => acc + item.Total, 0)
      }
      return _total.toFixed(2)
    }
  },
  methods: {
    formatDate(date, type = 'datetime') {
      return globals.formatDate(date, type)
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-list-wrapper {
  margin-top: 10px;
  padding: 0;
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 510px;
}
.custom-list {
  padding: 0;
  list-style-type: none;
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 440px;
  li {
    padding: 5px;
  }
  li:hover {
    background-color: rgb(219, 219, 219);
    cursor: pointer;
  }
  a {
    text-decoration: none;
    margin-top: 5px;
    margin-bottom: 5px;
  }
}
.custom-label {
  font-weight: 500;
}
</style>
